import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { IPermission, Route } from "@edgetier/watchtower-types";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request all permissions
 * @param url       Route URL
 */
const getPermissions = async (url: string) => {
    const permissions = await getAllPaginatedItems<IPermission>(url);
    return permissions.sort((permissionOne, permissionTwo) =>
        permissionOne.permission.localeCompare(permissionTwo.permission)
    );
};

/**
 * Get all permissions
 * @returns React Query result.
 */
const usePermissions = (configuration: UseQueryOptions<IPermission[], AxiosError<void>> = {}) => {
    const url = Route.Permissions;

    return useQuery<IPermission[], AxiosError<void>>([url], () => getPermissions(url), {
        ...configuration,
    });
};

export default usePermissions;
